import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=63cb469d&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=63cb469d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb469d",
  null
  
)

export default component.exports